(function () {
  var resizeBound = false;

  function scrollAmount(track) {
    return Math.max(Math.floor(track.clientWidth * 0.65), 260);
  }

  function updateCarouselNav(track, prev, next) {
    if (!track || !prev || !next) return;
    var nav = prev.closest('.tavern-drops-row__nav');
    if (!nav) return;

    var maxScroll = track.scrollWidth - track.clientWidth;
    var eps = 2;

    if (maxScroll <= eps) {
      nav.hidden = true;
      nav.setAttribute('aria-hidden', 'true');
      return;
    }

    nav.hidden = false;
    nav.removeAttribute('aria-hidden');

    var left = Math.max(0, track.scrollLeft);
    var canPrev = left > eps;
    var canNext = left < maxScroll - eps;

    prev.classList.toggle('tavern-drops-row__nav-btn--scrollable', canPrev);
    next.classList.toggle('tavern-drops-row__nav-btn--scrollable', canNext);

    prev.setAttribute('aria-disabled', canPrev ? 'false' : 'true');
    next.setAttribute('aria-disabled', canNext ? 'false' : 'true');
  }

  function bindGlobalsOnce() {
    if (resizeBound) return;
    resizeBound = true;
    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-tavern-drops-carousel]').forEach(function (carousel) {
        var track = carousel.querySelector('.tavern-drops-row__track');
        var prev = carousel.querySelector('[data-carousel-prev]');
        var next = carousel.querySelector('[data-carousel-next]');
        updateCarouselNav(track, prev, next);
      });
    });
  }

  function bindCarousel(carousel) {
    if (carousel.dataset.tavernCarouselNavBound === 'true') return;
    carousel.dataset.tavernCarouselNavBound = 'true';

    var track = carousel.querySelector('.tavern-drops-row__track');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;

    var runUpdate = function () {
      updateCarouselNav(track, prev, next);
    };

    prev.addEventListener('click', function () {
      if (!prev.classList.contains('tavern-drops-row__nav-btn--scrollable')) return;
      track.scrollBy({ left: -scrollAmount(track), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      if (!next.classList.contains('tavern-drops-row__nav-btn--scrollable')) return;
      track.scrollBy({ left: scrollAmount(track), behavior: 'smooth' });
    });

    track.addEventListener('scroll', runUpdate, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(runUpdate);
      ro.observe(track);
    }

    runUpdate();
    requestAnimationFrame(function () {
      requestAnimationFrame(runUpdate);
    });
  }

  function init() {
    bindGlobalsOnce();
    document.querySelectorAll('[data-tavern-drops-carousel]').forEach(bindCarousel);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
